import React from 'react';
import OMAccordion from '../OMComponents/OMAccordion/OMAccordion';
import PlainHtml from '../PlainHtml/PlainHtml';

export default properties => (
  <OMAccordion
    titleValue={properties.title}
    className={properties.className}
    onOpen={properties.onOpen}
    onClose={properties.onClose}
    accordionOpen={properties.isActive}
    afterInitialOpen={properties.afterInitialOpen}
  >
    <PlainHtml content={properties.content} />
  </OMAccordion>
);
